import React from 'react'
import Select from 'react-select'
import {Image, Text, View} from '@react-pdf/renderer'
import {isFieldEmpty} from '../../../helpers/utils'
import checkmark from '../../../resources/checkmark.png'
import {LabeledInfo, Title} from './common'
import styles from './styles'

const types = {checkbox: Checkbox, textarea: Textarea, panel: Panel, dropdown: Dropdown, radiopanel: RadioPanel}

function Dropdown (props) {
  const {name, count, grouped, value, options, context} = props
  const selects = value.filter(val => val != '').map((text, index) => { 
    const label = value.length < 2 ? name : `${name} ${index + 1}`
    const val = props.className == 'objectives' && /^Nivel*/.test(text) ? `${text}:` : text
    return (
      <View key={index} style={[styles.select, styles[`${props.className}Select`], styles[`${props.className}Select${index}`]]}>
        {!grouped && name && (<Text style={[styles.selectLabel, styles[`${props.className}SelectLabel`], styles[`${props.className}SelectLabel${props.index}`]]}>{label}:</Text>)}
        <Text style={[styles.selectText, styles[`${props.className}SelectText`], styles[`${props.className}SelectText${index}`]]}>{val}</Text>
      </View>)
 })
  return (
    <LabeledInfo styles={[styles[`${props.className}Dropdown${props.index}`], styles[`${props.className}Dropdown`], styles.dropdown]} label={grouped ? name : undefined}>
      <View style={[styles[`${props.className}Selects${props.index}`], styles[`${props.className}Selects`], styles.dropdown]}>
        {selects}
      </View>
    </LabeledInfo>
  )
}

function Checkbox (props) {
  return (
    <View style={[styles[`${props.className}Checkbox`], styles.checkbox]}>
      <Image src={checkmark} style={styles.checkmark} />
      <Text>{props.name}</Text>
    </View>)
}

function Textarea (props) {
  return (
    <LabeledInfo styles={[styles[`${props.className}Textarea`], styles.textarea]} label={props.name}>
      <Text style={[styles.textareaText, styles[`${props.className}TextareaText`]]}>{props.value}</Text>
    </LabeledInfo>
  )
}

function Panel (panelProps) {
  const {id, name, context, className} = panelProps
  const children = panelProps.children
    .map((props, contentId) => ({props, Element: types[props.type], contentId}))
    .filter(({Element, props}) => Element && !isFieldEmpty(props))
    .map(({Element, props, contentId}, index) => (
      <Element
        key={index}
        id={id}
        index={index}
        className={className}
        panelId={panelProps.contentId}
        contentId={contentId}
        context={context}
        {...props}
      />))

  return (
    <React.Fragment>
      {children.length > 0 && (
        <LabeledInfo styles={[styles[`${className}Panel`], styles[`${className}Panel${panelProps.index}`]]} label={name}>
          <View style={[styles[`${className}PanelChildren`],styles.children]}>
            {children}
          </View>
        </LabeledInfo>)}
    </React.Fragment>
  )
}

function RadioPanel (panelProps) {
  const {id, name, context, className} = panelProps
  const children = panelProps.children
    .filter(props => props.name === panelProps.value)
    .map((props, contentId) => {
      const radioId = `${id}-radio-${contentId}`
      const checked = panelProps.value === props.name
      const children = checked && props.value
        .filter(props => props.value)
        .map((props, index) => {
          return (<Checkbox key={index} className={className} {...props} />)
        })

      return (
        <React.Fragment key={contentId}>
          {children.length > 0 && (
            <LabeledInfo styles={[styles[`${className}RadioPanelOption`], styles[`${className}RadioPanelOption${panelProps.index}`]]} label={props.name}>
              <View style={[styles[`${className}RadioPanelOptionChildren`], styles.children]}>
                {children}
              </View>
            </LabeledInfo>)}
        </React.Fragment>)
    })
  return (
    <React.Fragment>
      {children.length > 0 && (
        <LabeledInfo styles={[styles[`${className}Panel`], styles[`${className}Panel${panelProps.index}`]]} label={name}>
          <View style={[styles[`${className}PanelChildren`],styles.children]}>
            {children}
          </View>
        </LabeledInfo>)}
    </React.Fragment>
  )
}

export default types
